import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import { api } from "../../Constant";
import axios from 'axios';
function Testimonial() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,


    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [testimonial, setTestimonial] = useState([])

  useEffect(() => {
    axios.post(api + "testimonial_list")
      .then((response) => {
        if (response.data.success === "true") {  // Check if the API call was successful
          setTestimonial(response.data.testimonial);  // Access the `category` array from response.data
        } else {
          console.log('No categories found');
        }
      })
      .catch((error) => {
        console.log('Error:', error);
      });
  }, []);
  return (
    <section className="testimonmial-section pt-5 pb-5">
      <div className="container">
        <div className="row">
          <Slider {...settings}>
            {testimonial.map((item) => {
              return (
                <div className="grid_col">
                  <div className="inner-box one" style={{
                    backgroundColor: item.background_color || "#D2E9F6",
                    '--border-color': item.border_color || '#1498d6'
                  }}>
                    <div className="row">
                      <div className="col-lg-8 col-md-6 col-xs-6">
                        <FontAwesomeIcon icon={faQuoteLeft}
                          style={{
                            color: item.border_color || '#1498D6', fontSize: '25px'
                          }}
                        />
                        <div className="sub-inner-box">
                          <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                          <span><b>{item.customer_name}, {item.location}</b></span>
                        </div>
                      </div>
                    </div>
                    <div className="img_box">
                      <img src={item.image} style={{ width: '60%' }} alt="img" />
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
